function NavMobile() {
	this.build();
}

NavMobile.prototype.build = function () {
	$('.open-navs').on('click', function () {
		$('body').addClass('nav-is-opened');
	});

	$('.close-navs').on('click', function () {
		$('body').removeClass('nav-is-opened');
	});
};
